import React from "react";

import AdminPageGuard from "../components/AdminPageGuard";
import Header from "./components/Header";
import Table from "./components/BoardTable/Table";
import "./adminBoard.scss";

function index() {
  return (
    <AdminPageGuard>
      <Header />
      <Table />
    </AdminPageGuard>
  );
}

export default React.memo(index);
